import React from "react";
import Navbar from "../components/Navbar";
import { motion } from "framer-motion";

const Leaderboard = () => {
  
  const leaderboardData = [
    { id: 1, name: "Adama Diallo", tests: 25, rank: 1, score: 1223, avatar: "/back.jpeg" },
    { id: 2, name: "Vous", tests: 25, rank: 2, score: 1000, avatar: "/back.jpeg" },
    { id: 3, name: "Adama Diallo", tests: 25, rank: 3, score: 999, avatar: "/back.jpeg" },
    { id: 4, name: "Adama Diallo", tests: 25, rank: 4, score: 666, avatar: "/back.jpeg" },
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <div className="w-full max-w-[1000px] mx-auto px-6 py-8">
       
        <h1 className="text-4xl font-extrabold text-orange-500 text-center mb-2">
          LEADERBOARD
        </h1>
        <p className="text-gray-500 text-center mb-6">
          Classement des meilleurs apprenants
        </p>

       
        <div className="bg-orange-500 text-white  rounded-t-3xl px-6 py-3 text-xl font-bold">
          Top Performers
        </div>

        <div className="bg-gray-50 rounded-b-3xl shadow-md divide-y">
          {leaderboardData.map((user) => (
            <motion.div
              key={user.id}
              className={`flex items-center justify-between px-6 py-4 
                ${user.name === "Vous" ? "bg-orange-50 rounded-full border-l-4 border-orange-400" : ""}
              `}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
            >
              
              <div className="flex items-center gap-4">
                <img
                  src={user.avatar}
                  alt={user.name}
                  className="w-12 h-12 rounded-full object-cover border border-gray-200"
                />
                <div>
                  <p className="font-semibold text-gray-900">{user.name}</p>
                  <p className="text-sm text-gray-500">{user.tests} tests complétés</p>
                </div>
              </div>

             
              <div className="flex items-center gap-6">
                <p className="font-semibold text-gray-600">
                  Rang <span className="font-bold text-gray-900">#{user.rank}</span>
                </p>
                <p className="font-bold text-teal-600 text-lg">{user.score}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Leaderboard;
